/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var Video = {};

( function( $ ) {
	
//	var masonry = $( '.masonry .play-wrap' );
//	var less = $( '.less-content .play-wrap' );
//	var related = $( '.related-articles .play-wrap' );
//
//	masonry.on( 'click', function( ev ) {
//		$( this ).parents( '.entry-thumbnail' ).find( "#pvideo" )[ 0 ].src += "&autoplay=1";
//		
//		ev.preventDefault();
//		
//		$( this ).parents( '.entry-thumbnail' ).find( 'img.visible' ).hide();
//		$( this ).parents( '.entry-thumbnail' ).find( 'iframe.visible' ).css( { "opacity":"1", "position":"static" } );
//		$( this ).parents( '.entry-thumbnail' ).find( '.play-video' ).css( { "position":"static" } );
//		$( this ).fadeOut();
//	});
//
//	less.on( 'click', function( ev ) {
//		$( this ).parents( '.entry-thumbnail' ).find( "#pvideo" )[ 0 ].src += "&autoplay=1";
//		ev.preventDefault();
//		$( '.thumbnail-img-wrap').find( 'img' ).hide();
//		$( '.custom-video').find( 'iframe.visible' ).css( { "opacity":"1" } );
//		$( this ).fadeOut();
//	});
//
//	less.on( 'click', function( ev ) {
//		$( this ).parents( '.entry-thumbnail' ).find( "#pvideo" )[ 0 ].src += "&autoplay=1";
//		ev.preventDefault();
//		$( this ).parents( '.related-item-wrap' ).find( 'img' ).hide();
//		$( this ).fadeOut();
//	});
	
	$( document ).ready( function() {
		// Blog post
		var blogPostContainer = $( '#BlogPostContainer' );
		
		blogPostContainer.find( '.play-wrap' ).click( function( e ) {
			e.preventDefault();
			
			blogPostContainer.find( '.thumbnail-img-wrap img' ).hide();
			
			var youtubeVideo = blogPostContainer.find( 'iframe.youtube-video' );
			
			youtubeVideo[0].src += '&autoplay=1';
			youtubeVideo.css( { 'opacity' : '1' } );
			
			$( this ).hide();
		} );
		
		// Related articles
		$( '.related-articles .related-item-wrap .play-wrap' ).click( function( e ) {
			e.preventDefault();
			
			var youtubeVideo = $( this ).parents( '.related-item-wrap' ).find( 'iframe.youtube-video' );
			
			youtubeVideo[0].src += '&autoplay=1';
			youtubeVideo.css( { 'opacity' : '1', 'z-index' : '5'} );
			
			$( this ).hide();
		} );
		
		// Front and category page
		$( '.masonry article .play-wrap' ).click( function( e ) {
			e.preventDefault();
			
			$( this ).parents( 'article' ).find( 'img' ).hide();
			
			
			var youtubeVideo = $( this ).parents( 'article' ).find( 'iframe.youtube-video' );
			
			youtubeVideo[0].src += '&autoplay=1';
			youtubeVideo.css( { 'opacity' : '1', 'position' : 'static' } );
			
			$( this ).parents( 'article' ).find( '.play-video' ).css( { 'position' : 'static' } );
			
			$( this ).hide();
		} );
	} );
	
} )( jQuery );